<template>
  <div class="bg">
    <search></search>
    <!-- <dataShow :weather="weather"></dataShow> -->
   <Footer></Footer>
  </div>
</template>

<script>
import search from "./components/search";
import Footer from "./components/Footer"
// import dataShow from "./components/dataShow";

export default {
  name: "App",
  components: {
    search,
    Footer
    // dataShow,
  },
};
</script>
   
<style>
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
 
 
  
 
}
.bg{
   background-image: url('../src/assets/bg.jpg');
   background-size: cover;
   background-repeat: no-repeat;
   height: 100vh;


}
</style>
